import React from 'react';
import { GraduationCap, Award } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Education = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const diplomas = t.education.diplomasList;
  const certificates = t.education.certificatesList;

  return (
    <section id="education" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4">
            {t.education.title}
          </h2>
          <div className="w-24 h-1 bg-gray-900 mx-auto"></div>
        </div>

        <div className="max-w-5xl mx-auto">
          <Tabs defaultValue="diplomas" className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-12">
              <TabsTrigger value="diplomas" className="text-base py-3">
                {t.education.diplomas}
              </TabsTrigger>
              <TabsTrigger value="certificates" className="text-base py-3">
                {t.education.certificates}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="diplomas" className="space-y-6">
              {diplomas.map((diploma, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-6 border border-gray-200 hover:border-gray-400 transition-all duration-300 hover:shadow-md"
                >
                  <div className="flex items-start gap-4">
                    <div className="mt-1 text-gray-900">
                      <GraduationCap className="w-6 h-6" />
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
                        <h3 className="text-xl font-serif font-semibold text-gray-900">
                          {diploma.degree}
                        </h3>
                        <span className="text-sm font-medium text-gray-600 mt-1 md:mt-0">
                          {diploma.period}
                        </span>
                      </div>
                      <p className="text-gray-700 font-medium mb-1">
                        {diploma.title}
                      </p>
                      <p className="text-gray-600">
                        {diploma.institution}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </TabsContent>

            <TabsContent value="certificates" className="space-y-6">
              {certificates.map((cert, index) => (
                <div
                  key={index}
                  className="bg-gray-50 p-6 border border-gray-200 hover:border-gray-400 transition-all duration-300 hover:shadow-md"
                >
                  <div className="flex items-start gap-4">
                    <div className="mt-1 text-gray-900">
                      <Award className="w-6 h-6" />
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
                        <h3 className="text-lg font-serif font-semibold text-gray-900">
                          {cert.issuer}
                        </h3>
                        <span className="text-sm font-medium text-gray-600 mt-1 md:mt-0">
                          {cert.year}
                        </span>
                      </div>
                      <p className="text-gray-700">
                        {cert.title}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default Education;